import { RecoveryBoard } from "@/components/recovery-board/RecoveryBoardGame";
import { useMembership } from "@/hooks/useMembership";

/**
 * Homepage Recovery Board: the real board. Members play their saved game right
 * here; visitors can roll the dice, then are invited to become a member.
 */
export function HomeRecoveryBoard() {
  const membership = useMembership();
  const hasAccess = membership.isMember || membership.isAdmin;
  return (
    <div className="mx-auto w-full max-w-5xl">
      <p className="mb-1 text-center text-[10px] font-semibold uppercase tracking-[0.28em] text-[var(--gold-deep)]">
        A gentle game
      </p>
      <RecoveryBoard embedded guest={!hasAccess} />
    </div>
  );
}
